import { render, staticRenderFns } from "./LaboratoryServiceTerms.vue?vue&type=template&id=7cc3cb8a&"
import script from "./LaboratoryServiceTerms.vue?vue&type=script&lang=js&"
export * from "./LaboratoryServiceTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports